// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    TableCell as MaterialUITableCell,
    TableCellProps as MaterialUITableCellProps
} from '@material-ui/core'

interface TableCellBaseProps { }
export type TableCellProps = Partial<MaterialUITableCellProps> & TableCellBaseProps

export const TableCell: FC<TableCellProps> = ({ ...props }) => {
    return <MaterialUITableCell {...props}></MaterialUITableCell>
}
